export const getLocaleUrl = (url, lang = "it", languages = []) => {
	if (url.startsWith("/")) {
		const [languagePrefix, ...rest] = url.replace(/^\/|\/$/g, "").split("/");

		if (languages.includes(languagePrefix)) {
			url = "/" + lang + "/" + rest.join("/");
		} else {
			url = "/" + lang + "/" + languagePrefix + "/" + rest.join("/");
		}
	}

	url = url.replace(/\/\//g, "/");
	return url;
};
